import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import useGlobal from '../util/Global';
import { useCookies } from 'react-cookie';
import authServicev2 from '../service/AuthServicev2';
import useMessage from '../util/useMessage';
import Config from '../Config';
import { MessageType } from '../util/Enums';
import KullaniciRolleriservice from '../service/IKIseAlimServices/KullaniciRolleriService';
import { ActionType } from '../store/ActionType';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useAppCookies } from '../util/useAppCookies';
import Accountservice from '../service/Core/AccountService';


const SwitchDialog = ({ open, onClose, selectedKey }) => {

    const { g } = useGlobal();
    const history = useHistory();
    const dispatch = useDispatch();
    const showMessage = useMessage();
    const full = useSelector(state => state.auth);

    const [tenantList, setTenantList] = useState([]);
    const [selTenant, setSelTenant] = useState(null);

    // const [cookies, setCookie, removeCookie] = useCookies(['access_token', 'refresh_token', 'isMaster', 'tenantName']);

    const { setUser } = useAppCookies();

    const [loading, setLoading] = useState(false);


    const onSelectTenant = async () => {

        if (selTenant == null) {
            showMessage(g("message.SelectTenantPlease"), MessageType.ERROR);
        }

        setLoading(true);



        Accountservice.user = full.user;

        const { isSuccess, message, user, pageurl } = await Accountservice.loginAsTenant(selTenant);


        if (!isSuccess) {
            showMessage(g(message), MessageType.ERROR);
            return;
        }

        setUser(user);


        dispatch({
            type: ActionType.LOGIN,
            user: user,
            token: user.accessToken,
            tenantUser: user.masterTenant,
            masterUser: user.masterToken
        });



        history.push(pageurl);

        setLoading(false);


    }



    const handleSelectTenant = (event, newValue) => {
        setSelTenant(newValue);
    };



    useEffect(() => {
        // If selectedKey or open has changed, update the search data
        if (open) {
            const accessToken = full.user.accessToken;
            authServicev2.getAuthorizedTenants(accessToken).then((list) => setTenantList(list));
        } else {
            setTenantList([]);
        }

    }, [open]);


    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth={"sm"}
            scroll="paper"
        >
            <DialogTitle>
                {g('title.SelectTenant')}
            </DialogTitle>

            <DialogContent dividers={true}>
                <Autocomplete
                    options={tenantList}
                    getOptionLabel={(option) => option.masterTenant.name}
                    onChange={handleSelectTenant}
                    renderInput={(params) => <TextField {...params} label="Seçiniz" variant="outlined" />}
                />

            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={() => onSelectTenant()} disabled={!selTenant || loading}>
                    {g('button.ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );

};


export default SwitchDialog;
